import { render, staticRenderFns } from "./HolderAccessControl.vue?vue&type=template&id=0259bb82"
import script from "./HolderAccessControl.vue?vue&type=script&lang=js"
export * from "./HolderAccessControl.vue?vue&type=script&lang=js"
import style0 from "./HolderAccessControl.vue?vue&type=style&index=0&id=0259bb82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports